// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Billing Account API
 * Endpoints for managing billing accounts, marketplaces, payment processors, and entitlements.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EntitlementResponse } from './EntitlementResponse';
import {
  EntitlementResponseFromJSON,
  EntitlementResponseFromJSONTyped,
  EntitlementResponseToJSON,
  EntitlementResponseToJSONTyped,
} from './EntitlementResponse';

/**
 *
 * @export
 * @interface GetEntitlementsResponse
 */
export interface GetEntitlementsResponse {
  /**
   *
   * @type {Array<EntitlementResponse>}
   * @memberof GetEntitlementsResponse
   */
  data?: Array<EntitlementResponse>;
}

/**
 * Check if a given object implements the GetEntitlementsResponse interface.
 */
export function instanceOfGetEntitlementsResponse(
  value: object,
): value is GetEntitlementsResponse {
  return true;
}

export function GetEntitlementsResponseFromJSON(
  json: any,
): GetEntitlementsResponse {
  return GetEntitlementsResponseFromJSONTyped(json, false);
}

export function GetEntitlementsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GetEntitlementsResponse {
  if (json == null) {
    return json;
  }
  return {
    data:
      json['data'] == null
        ? undefined
        : (json['data'] as Array<any>).map(EntitlementResponseFromJSON),
  };
}

export function GetEntitlementsResponseToJSON(
  json: any,
): GetEntitlementsResponse {
  return GetEntitlementsResponseToJSONTyped(json, false);
}

export function GetEntitlementsResponseToJSONTyped(
  value?: GetEntitlementsResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    data:
      value['data'] == null
        ? undefined
        : (value['data'] as Array<any>).map(EntitlementResponseToJSON),
  };
}
